export let SC="!@#$%^&*()."
export let UC="ABCDEFGHIJKLMNOPQRSTUVWXYZ"
export let LC="abcdefghijklmnopqsrtuvwxyz"
export let NC="0123456789"